var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},[_vm._v(" 评估机构 ")])
}
var staticRenderFns = []

export { render, staticRenderFns }